<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          <font-awesome-icon icon="dollar-sign"/>
          {{ $t('title') }}
        </h1>
      </div>
    </div>
    <div>
      <div class="row">
        <div class="col-12">
          <div class="tile">
            <div class="form-inline">
              <form-select :model="filterFormModel" attribute="group" class="mr-1" @input="load" :options="[
                    {value: 'day', text: $t('byDay')},
                    {value: 'week', text: $t('byWeek')},
                    {value: 'month', text: $t('byMonth')},
                    {value: 'client', text: $t('byClient')},
                    // {value:'sales',text:$t('bySales')},
                    // {value:'account',text:$t('byAccounts')}
              ]">
              </form-select>
              <client-select :model="filterFormModel"  attribute="client" @input="load" :isFilter="true" :place-holder="$t('selectClient')"
                             class="mr-1"></client-select>
<!--              <admin-user-select :model="filterFormModel" attribute="sales" @input="load" :place-holder="$t('selectSales')" class="mr-1"></admin-user-select>-->
<!--              <admin-user-select :model="filterFormModel" attribute="account" @input="load" :place-holder="$t('selectAccount')" class="mr-1"></admin-user-select>-->
              <time-range-picker :model="filterFormModel" @input="load" :label="$t('time')" :default-shortcut="6" class="mr-1"></time-range-picker>
              <button @click="load" class="btn btn-primary mr-1">{{ $t('search') }}</button>
              <button @click="reset" class="btn btn-secondary mr-1">Reset</button>
            </div>
          </div>
          <div class="tile">
            <div class="row">
              <div class="col">
                <div>
                  <apexchart :height="300" :options="chartOptions" :series="chartData"></apexchart>
                </div>
              </div>
            </div>
          </div>
          <div class="tile">
            <div class="table-responsive c-template-table">
              <table class="table table-hover table-bordered">
                <thead>
                <tr>
                  <th rowspan="2"></th>
                  <th class="text-center" colspan="3">{{ $t('total') }}</th>
                  <th class="text-center" colspan="3">{{ $t('new') }}</th>
                  <th class="text-center" colspan="3">{{ $t('extend') }}</th>
                  <th class="text-center" colspan="2">{{ $t('user') }}</th>
                </tr>
                <tr>
                  <th class="text-center" style="min-width: 100px">{{ $t('discountAmount') }}</th>
                  <th class="text-center" style="min-width: 100px">{{ $t('numberOfDayGifted') }}</th>
                  <th class="text-center" style="min-width: 100px">{{ $t('numberOfUserGifted') }}</th>
                  <th class="text-center" style="min-width: 100px">{{ $t('discountAmount') }}</th>
                  <th class="text-center" style="min-width: 100px">{{ $t('numberOfDayGifted') }}</th>
                  <th class="text-center" style="min-width: 100px">{{ $t('numberOfUserGifted') }}</th>
                  <th class="text-center" style="min-width: 100px">{{ $t('discountAmount') }}</th>
                  <th class="text-center" style="min-width: 100px">{{ $t('numberOfDayGifted') }}</th>
                  <th class="text-center" style="min-width: 100px">{{ $t('numberOfUserGifted') }}</th>
                  <th class="text-center" style="min-width: 100px">{{ $t('discountAmount') }}</th>
                  <th class="text-center" style="min-width: 100px">{{ $t('numberOfUserGifted') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr class="bg-success">
                  <td><b class="text-uppercase">{{ $t('totals') }}</b></td>
                  <td class="text-center"><span class="text-blue">{{ sum.discountAmount | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ sum.numberOfDayGifted | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ sum.numberOfUserGifted | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ sum.newDiscountAmount | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ sum.newNumberOfDayGifted | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ sum.newNumberOfUserGifted | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ sum.extendDiscountAmount | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ sum.extendNumberOfDayGifted | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ sum.extendNumberOfUserGifted | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ sum.userDiscountAmount | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ sum.userNumberOfUserGifted | numFormat }}</span></td>
                </tr>
                <tr class="bg-warning">
                  <td><b class="text-uppercase">{{ $t('average') }}</b></td>
                  <td class="text-center"><span class="text-blue">{{ avg.discountAmount | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ avg.numberOfDayGifted | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ avg.numberOfUserGifted | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ avg.newDiscountAmount | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ avg.newNumberOfDayGifted | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ avg.newNumberOfUserGifted | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ avg.extendDiscountAmount | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ avg.extendNumberOfDayGifted | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ avg.extendNumberOfUserGifted | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ avg.userDiscountAmount | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ avg.userNumberOfUserGifted | numFormat }}</span></td>
                </tr>
                <tr :key="index" v-for="(item, index) in data">
                  <td style="min-width: 200px"><b>{{ label(item) }}</b></td>
                  <td class="text-center"><span class="text-blue">{{ item.discountAmount | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ item.numberOfDayGifted | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ item.numberOfUserGifted | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ item.newDiscountAmount | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ item.newNumberOfDayGifted | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ item.newNumberOfUserGifted | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ item.extendDiscountAmount | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ item.extendNumberOfDayGifted | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ item.extendNumberOfUserGifted | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ item.userDiscountAmount | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ item.userNumberOfUserGifted | numFormat }}</span></td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import TimeRangePicker from "../../components/TimeRangePicker";
import moment from 'moment';
import VueApexCharts from 'vue-apexcharts';
import ClientSelect from "../../components/ClientSelect";
// import AdminUserSelect from "@/components/AdminUserSelect";

export default {
  components: {ClientSelect, TimeRangePicker, 'apexchart': VueApexCharts},
  data: function () {
    return {
      filterFormModel: {
        group: 'day',
        client: null,
        sales: null,
        account: null,
      },
      loading: true,
      data: [],
      chartOptions: {
        xaxis: {},
        chart: {
          zoom: {
            enabled: false
          },
          type: 'line'
        }
      },
      chartData: [],
      sum: 0,
      avg: 0
    }
  },
  methods: {
    load() {
      if (!this.filterFormModel.to || !this.filterFormModel.from) {
        this.$swal({
          text: "Bạn cần chọn khoảng thời gian báo cáo",
          icon: 'warning'
        });
        return;
      }
      let loader = this.$loading.show();
      this.loading = true;
      this.$service.get('/report/promotion', {
        params: this.filterFormModel
      }).then(response => {
        this.data = response.data;
        this.sum = {};
        this.avg = {};
        this.data.forEach(item => {
          for (let key in item) {
            if (!['label'].includes(key)) {
              item[key] = Math.abs(item[key]);
              if (!this.sum[key]) {
                this.sum[key] = 0;
              }
              this.sum[key] += Math.abs(item[key]);
            }
          }
        });
        for (let key in this.sum) {
          this.avg[key] = Math.round(this.sum[key] / this.data.length);
        }
        this.chartOptions = {
          xaxis: {
            categories: this.data.map(d => this.label(d)).slice(0, 99).reverse(),
            labels: {
              rotate: 0
            },
            tooltip: {
              enabled: false,
            }
          },
          yaxis: {
            labels: {
              formatter: function (value) {
                return new Intl.NumberFormat().format(value);
              }
            },
          },
          chart: {
            zoom: {
              enabled: false
            },
            type: this.filterFormModel.group === 'day' ? 'line' : 'bar'
          }
        };
        this.chartData = [
          {
            name: this.$t('discountAmount'),
            data: this.data.map(d => d.discountAmount).slice(0, 99).reverse(),
          },
          {
            name: this.$t('numberOfDayGifted'),
            data: this.data.map(d => d.numberOfDayGifted).slice(0, 99).reverse(),
          },
          {
            name: this.$t('numberOfUserGifted'),
            data: this.data.map(d => d.numberOfUserGifted ).slice(0, 99).reverse(),
          },
        ];
      }).finally(() => {
        loader.hide();
        this.loading = false;
      });
    },
    label(item) {
      if (item.label || item.clientSales || item.clientCategory) {
        return item.label;
      }
      if (!isNaN(item._id)) {
        if (this.filterFormModel.group === 'day') {
          return moment(item._id, 'x').format('ll');
        }
        if (this.filterFormModel.group === 'week') {
          return `${moment(item._id, 'x').format('ll')} --> ${moment(item._id, 'x').add(6, 'day').format('ll')}`;
        }
        if (this.filterFormModel.group === 'month') {
          return moment(item._id, 'x').startOf('month').format('MM/YYYY');
        }
      }
    },
    reset() {
      this.filterFormModel = {
        group: 'day',
        client: null,
        from: moment().startOf('month').format('x'),
        to: moment().endOf('month').format('x'),
      };
      this.$bus.$emit('resetTimeRangePicker');
      this.load();
    }
  },
  mounted() {
    this.load();
  },
  i18n: {
    messages: {
      en: {
        title : 'Promotion on orders',
        byDay: 'By day',
        byWeek: 'By week',
        byMonth: 'By month',
        byClient: 'By client',
        bySales: 'By sales',
        byAccounts: 'By supporter',
        new: 'New',
        user: 'Buy more user',
        extend: 'Extend',
        upgrade: 'Upgrade',
        totals: 'Total',
        average: 'Average',
        selectSales: 'Select BD',
        selectAccount: 'Select AM',
        discountAmount: "Discount Amount",
        numberOfDayGifted: "Number of day gifted",
        numberOfUserGifted: "Number of user gifted",
      },
      vi: {
        title : 'Khuyến mãi trên đơn hàng',
        byDay: 'Theo ngày',
        byWeek: 'Theo tuần',
        byMonth: 'Theo tháng',
        byClient: 'Theo client',
        bySales: 'Theo sales',
        byAccounts: 'Theo chăm sóc',
        new: 'Mua mới',
        user: 'Mua thêm',
        extend: 'Gia hạn',
        totals: 'Tổng',
        average: 'Trung bình',
        selectSales: 'Chọn BD',
        selectAccount: 'Chọn AM',
        discountAmount: "Số tiền giảm giá",
        numberOfDayGifted: "Số ngày tặng thêm",
        numberOfUserGifted: "Số user tặng thêm",
      }
    }
  }
}
</script>
